import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { CanActivateFn } from '@angular/router';

export abstract class ActivationGuardBase {
  // WARNING! do not optimize route away, since here it would work but in the injection it is not working (in routing modules) therefore leave it here so nobody is tempted to remove it there!
  canActivate: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
    const url: string = state.url;

    return this.checkLogin(url);
  }

  abstract checkLogin(url: string): boolean;
}
